import { TFunction } from "i18next";

import { Button, Text } from "@pentabd/ui";
import { NavigateFunction } from "react-router-dom";

export const TableColumn = (
  t: TFunction<"translation", undefined>,
  navigate: NavigateFunction,
) => {
  return [
    {
      id: 1,
      key: "title",
      name: t("PROCUREMENT_DETAILS.TABLE.COLUMN.NAME"),
      render: (title: string) => <Text color="subtitle1">{title}</Text>,
    },
    {
      id: 2,
      key: "packageRefNo",
      name: t("PROCUREMENT_DETAILS.TABLE.COLUMN.PACKAGE_REF_NO"),
      render: (packageRefNo: string) => (
        <Text color="subtitle1">{packageRefNo}</Text>
      ),
    },
    {
      id: 3,
      key: "allocatedBudget",
      name: t("PROCUREMENT_DETAILS.TABLE.COLUMN.TOTAL_BUDGET"),
      render: (allocatedBudget: number) => (
        <Text color="subtitle1">{allocatedBudget}</Text>
      ),
    },
    {
      id: 4,
      key: "id",
      name: "",
      render: (id: number | string) => {
        return (
          <Button
            type="light"
            size="sm"
            fill="outline"
            onClick={() => {
              navigate(`${id}`);
            }}
          >
            {t("PROCUREMENT_ANNUAL_PLAN.TABLE.ACTIONS.DETAILS_BUTTON_TEXT")}
          </Button>
        );
      },
    },
  ];
};
